const messages = {
  title: "Markedsføringssamtykker",
  required: "Påkrevd",
  answered: "✓ Besvart",
  read: "Lest",
  notRead: "Ikke lest",
  alreadyAnswered: "Allerede besvart",
  requiredQuestionsMustBeAccepted: "{count} påkrevd spørsmål{plural} må godtas",
  pleaseAnswerQuestions: "Vennligst svar på følgende spørsmål:",
  iAccept: "Jeg godtar",
  scrollToUnlock: "Rull til bunnen for å låse opp",
  fieldRequired: "Dette feltet er påkrevd",
  scrollToContinue: "↓ Rull til bunnen for å fortsette",
  saving: "Lagrer...",
  saveConsents: "Lagre samtykker",
  allRequiredAccepted: "✓ Alle påkrevde spørsmål godtatt",
  requiredConsentsCompleted: "{completed}/{total} påkrevde samtykker fullført",
  selectConsentToView: "Velg et samtykke fra listen for å vise innholdet",
  readAllContentFirst: "Les alt innhold først: {names}",
  acceptAllRequiredIn: "Godta alle påkrevde spørsmål i: {names}",
  acceptAllBeforeSaving: "Vennligst godta alle påkrevde spørsmål før du lagrer.",
  failedToSave: "Kunne ikke lagre samtykker. Vennligst prøv igjen.",
  errorSaving: "Det oppstod en feil ved lagring av samtykker. Vennligst prøv igjen.",
  failedToLoad: "Kunne ikke laste samtykker. Vennligst oppdater siden.",
  viewPdf: "Vis PDF",
  requiredConsentTitle: "Påkrevd samtykke",
  acceptAndContinue: "Godta og fortsett",
};

export default {
  messages,
};
